<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card title="Update user details">
          <form @submit.prevent="updateUser">
            <!-- <label>Username</label>
            <fieldset class="form-group">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder="name"
                v-model="user.username"
              />
            </fieldset> -->

            <label>Name</label>
            <fieldset class="form-group ">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.name"
              />
            </fieldset>            

            <label>Email</label>
            <fieldset class="form-group ">
              <input 
                type="email"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.email"
              />
            </fieldset>

            <label>Phone</label>
            <fieldset class="form-group ">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.phone"
              />
            </fieldset>                    

            <label v-if="isAdmin || currentUser.id === user.id">Password</label>
            <fieldset v-if="isAdmin || currentUser.id === user.id" class="form-group">
              <input 
                type="password"
                id="password-input"
                class="form-control form-control-lg"
                placeholder="password"
                v-model="user.password"
              />
              <div class="show-password" @click="toggleShowPassword($event)">
                <span :class="isPasswordShowing ? 'fa fa-eye-slash' : 'fa fa-eye'"></span>
              </div>
            </fieldset>

            <label v-if="isAdmin">Grant Access</label>
            <fieldset v-if="isAdmin" class="form-group">
              <ul class="user-access-list">
                <li>
                  <label for="assets"><input type="checkbox" id="assets" v-model="user.access" value="assets"> Assets</label>
                </li>
                <li>
                  <label for="pages"><input type="checkbox" id="pages" v-model="user.access" value="pages"> Pages</label>
                </li>
                <li>
                  <label for="navigation"><input type="checkbox" id="navigation" v-model="user.access" value="navigation"> Navigation</label>
                </li>
                <li>
                  <label for="live"><input type="checkbox" id="live" v-model="user.access" value="live"> Live</label>
                </li>
                <li>
                  <label for="settings"><input type="checkbox" id="settings" v-model="user.access" value="settings"> Settings</label>
                </li>
                <li>
                  <label for="users"><input type="checkbox" id="users" v-model="user.access" value="users"> Create / Update Users</label>
                </li>
                <li>
                  <label for="email"><input type="checkbox" id="email" v-model="user.access" value="email-properties"> Backend Email Properties</label>
                </li>
              </ul>
            </fieldset>

            <fieldset class="form-group">
              <input 
                type="submit"
                class="btn btn-primary"
                value="Update"
              />
            </fieldset>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { USER_EDIT, FETCH_USER_BY_ID } from '@/store/actions.type'

export default {

  data() {
    return {
      isPasswordShowing: false,
      user: {}
    }
  },

  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },

    isAdmin () {
      return this.$store.getters.currentUser.isAdmin
    }
  },

  beforeMount() {
    const userId = this.$route.params.userId
    this.$store.dispatch(FETCH_USER_BY_ID, userId).then(res => {
      this.user = res.user
    })
  },

  methods: {
    updateUser() {
      this.$store.dispatch(USER_EDIT, this.user).then(() => {
        this.$notify({
          message: 'User updated',
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        })
      }).catch(() => {
        this.$notify({
          message: 'An error occured',
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        })
      })
    },

    toggleShowPassword(event) {
      let passwordInput = document.querySelector('#password-input')
      
      this.isPasswordShowing = this.isPasswordShowing ? false : true
      passwordInput.type = this.isPasswordShowing ? 'text' : 'password'
    }
  }
}
</script>
<style lang="scss" scoped>

.form-group {
  position: relative;
}

.show-password {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.user-access-list {
  list-style: none;
  padding: 0 16px;

  li {
    label {
      font-size: 14px;
      user-select: none;
    }
  }
}

.user-list {
  list-style: none;
  padding: 0;

  > :nth-child(even) {
    background: #f1f1f1;
  }

  .user {
    align-items: center;
    display: flex;
    padding: 6px 16px;

    &__username {
      font-size: 16px;
    }

    &__email {
      font-size: 14px;
      margin-left: .75em;
      opacity: .7;
    }

    &__btn {
      margin-left: auto;
    }
  }
}
</style>
